/**
 * Черновики сообщений по беседам: текст сохраняется в localStorage под
 * ключом `orion_draft_<conversationId>`, поэтому переживает переключение
 * чата, перезагрузку страницы и случайное закрытие вкладки.
 *
 * Черновик — вспомогательное удобство: если хранилище недоступно (приватный
 * режим браузера, переполнение квоты), чат продолжает работать как раньше.
 */

/** Префикс ключа черновика; сам ключ — `orion_draft_<id>` беседы. */
export const DRAFT_PREFIX = 'orion_draft_';

/** Ключ черновика беседы или `null`, если беседы ещё нет. */
export const draftKey = (conversationId?: string | null): string | null =>
    conversationId ? `${DRAFT_PREFIX}${conversationId}` : null;

/** Текст черновика; пустая строка, если записи нет или хранилище недоступно. */
export const readDraft = (conversationId?: string | null): string => {
    const key = draftKey(conversationId);
    if (!key) return '';
    try {
        return window.localStorage.getItem(key) ?? '';
    } catch {
        return '';
    }
};

/**
 * Сохранить черновик. Пустой (или состоящий из пробелов) текст удаляет
 * запись, чтобы не копить пустые ключи в localStorage.
 */
export const writeDraft = (conversationId: string | undefined | null, text: string): void => {
    const key = draftKey(conversationId);
    if (!key) return;
    try {
        if (text.trim()) {
            window.localStorage.setItem(key, text);
        } else {
            window.localStorage.removeItem(key);
        }
    } catch {
        // Приватный режим или переполненная квота — черновик не критичен.
    }
};

/** Удалить черновик — вызывается после отправки сообщения. */
export const clearDraft = (conversationId?: string | null): void => {
    const key = draftKey(conversationId);
    if (!key) return;
    try {
        window.localStorage.removeItem(key);
    } catch {
        // см. writeDraft: недоступное хранилище не должно ломать отправку.
    }
};
